"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fees = fees;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _drr = require("../util/drr");

// Copyright 2017-2019 @polkadot/api-derive authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function fees(api) {
  return () => {
    // FIXME Remove fees checks, only use balances (fees is a removed module now)
    return (0, _rxjs.combineLatest)([api.query.balances.creationFee(), api.query.balances.existentialDeposit(), api.query.balances.transactionBaseFee(), api.query.balances.transactionByteFee(), api.query.balances.transferFee()]).pipe((0, _operators.map)((_ref) => {
      let [creationFee, existentialDeposit, transactionBaseFee, transactionByteFee, transferFee] = _ref;
      return {
        creationFee,
        existentialDeposit,
        transactionBaseFee,
        transactionByteFee,
        transferFee
      };
    }), (0, _drr.drr)());
  };
}